"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var DropdownLinkOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownLinkOption"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var context_1 = require("../context");
var utils_1 = require("../utils");
var DropdownGroup_1 = __importDefault(require("./DropdownGroup"));
var ActionsGroup = function (_a) {
    var item = _a.item;
    var openModal = react_1.default.useContext(context_1.InvoiceModalContext);
    var makeHandleClick = function (action) { return function () { return openModal === null || openModal === void 0 ? void 0 : openModal({ modalKey: action, item: item, itemId: item.id }); }; };
    var actions = (0, utils_1.getAvailableActions)(item).actions;
    var pdfLink = (0, utils_1.getPDFLink)(item);
    if (!actions.length && !pdfLink) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(DropdownGroup_1.default, __assign({ categoryTitle: "Actions" }, { children: [actions.map(function (action) { return ((0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: (0, utils_1.getBtnText)(action, item), autoFocus: true, onClick: makeHandleClick(action) }, action)); }), pdfLink && (0, jsx_runtime_1.jsx)(DropdownLinkOption_1.default, { title: "Download PDF", href: "".concat(pdfLink) })] })));
};
exports.default = ActionsGroup;
